import { connect } from 'react-redux'

import { logout } from '../actions'
import Logout from '../components/Logout'


const mapDispatchToProps = dispatch => {
    return {
        onLogout: () => dispatch(logout()) 
    }
}

export default connect(null, mapDispatchToProps)(Logout)



/** WEBPACK FOOTER **
 ** ./src/containers/LogoutContainer.js
 **/